import React, { ReactNode } from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { URL } from '@sputnik/resources/constants'

interface PrivacyPolicyLinkProps {
  dataTestId?: string
  className?: string
  alternateLinkString?: ReactNode
  onClick?: () => void
}

const PrivacyPolicyLink = ({ dataTestId, className, alternateLinkString, onClick }: PrivacyPolicyLinkProps) => {
  const { BILL_PRIVACY_NOTICE } = URL
  return (
    <TextLink
      className={className}
      dataTestId={dataTestId}
      href={BILL_PRIVACY_NOTICE}
      size={TextLinkSizes.REGULAR}
      target='_blank'
      useDataTestId={dataTestId}
      onClick={onClick}
    >
      {!alternateLinkString && (
        <FormattedMessage
          defaultMessage='Privacy Policy'
          id='sputnik.PrivacyPolicyLink__vx0nkZ'
        />
      )}
      {alternateLinkString && alternateLinkString}
    </TextLink>
  )
}

export default PrivacyPolicyLink
